import { apiRequest, readJsonOrThrow } from "@/api/client";

export async function createSuggestion(session, payload) {
  const response = await apiRequest("/momo/suggestions", {
    method: "POST",
    session,
    body: payload,
  });
  return readJsonOrThrow(response, "Failed to create suggestion");
}

export function createCancellationFeedback(session, { reasonType, message }) {
  return createSuggestion(session, {
    category: "other",
    subject: `Cancellation: ${reasonType}`,
    description: message,
    isCancellation: true,
  });
}
